import { EnemyBipedSkinType, SpineDataName } from "../../../spine-config/spine-config"
import { VariantAI } from "../ai-types"
import { ENEMY_NAME } from "../enemy-names"

export const mushie2: VariantAI = {
    extends: ENEMY_NAME.MUSHIE_1,
    name: ENEMY_NAME.MUSHIE_2,
    appearance: {
        asset: SpineDataName.MUSHIE_2,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
    },
}

export const mushie3: VariantAI = {
    extends: ENEMY_NAME.MUSHIE_1,
    name: ENEMY_NAME.MUSHIE_3,
    appearance: {
        asset: SpineDataName.MUSHIE_3,
        spriteSheet: true,
        skin: EnemyBipedSkinType.DEFAULT,
    },
}